import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogTitle-root": {
        padding: "20px",
        textAlign: "center"
      },
      "& .MuiDialogContent-root": {
        padding: "24px 24px 0 24px",
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 24px 16px 24px",
        columnGap: 16,
        justifyContent: "space-between"
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      },
      "& .MuiTypography-h6": {
        width: "100%"
      },
      "& .MuiGrid-root": {
        padding: "2px"
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16
    },
    btnAction: {
      display: "flex",
      alignItems: "center",
      gap: 8
    },
    typeButton: {
      height: 48,
      borderColor: "#000000",
      "&:hover": {
        borderColor: "#595959ff !important",
        background: "#f6f6f6ff !important"
      }
    },
    typeButtonSubmit: {
      padding: "0 4rem",
      background: "#009FB8 !important",
      "&:hover": {
        background: "#007B9E !important"
      }
    },
    dialogTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: theme.palette.gardient.medium + " !important",
      borderRadius: "16px 16px 0 0",
      width: "100%"
    },
    titleHeader: {
      color: theme.palette.common.white,
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "20px !important",
      fontWeight: 400
    },
    closeIcon: {
      cursor: "pointer"
    },
    detailsContainer: {
      display: "flex",
      textAlign: "start",
      "& p": {
        margin: "0 !important"
      }
    },
    required: {
      color: "red"
    },
    inputTitleBlock: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      marginTop: 16,
      padding: "4px 14px",
      background: "#CDFAFF"
    },
    inputBlock: {
      display: "flex",
      gap: 8,
      padding: "4px 14px",
      background: "#E9FDFF",
      alignItems: "flex-start !important",
      width: "100% !important"
    },
    btnAdd: {
      fontSize: "14px !important",
      fontWeight: 700
    },
    btnSubmit: {
      color: theme.palette.common.white,
      fontSize: "14px !important",
      fontWeight: 700
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    deleteBox: {
      display: "flex",
      justifyContent: "center",
      cursor: "pointer"
    },
    lengthItem: {
      fontSize: "14px !important",
      fontWeight: 400
    },
    footerActions: {
      display: "flex",
      alignItems: "center",
      padding: "0 24px 16px 24px"
    },
    infoIcon: {
      width: 22,
      height: 22,
      marginRight: 6
    },
    itemsBlock: {
      display: "flex",
      gap: 4,
      flexDirection: "column",
      maxHeight: "260px",
      overflowY: "auto"
    },
    validateError: {
      fontSize: "12px !important",
      fontWeight: 400,
      marginTop: 4,
      color: "#FF2600"
    },
    inputTextField: {
      width: "100%",
      paddingRight: "8px !important"
    }
  }),
  { name: "DialogAddMaterial" }
);

export default useStyles;
